import { writable } from "svelte/store";
import type { Warehouse } from "@shared/types/Warehouse";
import type { SpeakeasyPageInfo } from "@shared/types/Pagination";
import { getWarehouseData } from "@modern/services/retailer/warehouse_service";

export type WarehouseStore = {
  loaded: boolean;
  failed: boolean;
  data: {
    warehouses: Warehouse[];
    pageInfo: SpeakeasyPageInfo;
    defaultWarehouse: Warehouse;
    selectedWarehouse: Warehouse;
  };
};

export type WarehouseData = {
  id: number;
  name: string;
  distributor_id?: number;
  city: string;
  state: string;
  zipcode: string;
  county: string;
  for_delivery: boolean;
  for_pickup: boolean;
};

const initialWarehouseStore: WarehouseStore = {
  loaded: false,
  failed: false,
  data: {
    warehouses: [],
    pageInfo: null,
    defaultWarehouse: null,
    selectedWarehouse: null,
  },
};

const _store = writable<WarehouseStore>(initialWarehouseStore);
const { set, update, subscribe } = _store;

const warehouseStore = {
  set,
  update,
  subscribe,
  load: async (
    distributor_id: number,
    skus: String[] = [],
    after: String = null,
    stockSiteId: String = null,
  ) => {
    const data = await getWarehouseData(distributor_id, skus, after, stockSiteId);
    set(data);
  },
  getWarehouses: async (
    distributor_id: number,
    skus: String[] = [],
    after: String = null,
    stockSiteId: String = null,
    forProductLine: boolean = true,
  ) => {
    const data = await getWarehouseData(distributor_id, skus, after, stockSiteId, forProductLine);
    return data;
  },
};

export default warehouseStore;
